import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { trackBookingCtaClick, EventSource } from '../utils/analytics';

/** Shared accessible name for all in-app links to `/book` (WCAG 3.2.4). Visible text may differ. */
export const BOOK_APPOINTMENT_ARIA_LABEL = 'Book a pet dental appointment';

type Props = Omit<LinkProps, 'to'> & {
  to?: LinkProps['to'];
  /**
   * Where on the site this CTA lives, used for funnel analytics.
   * Defaults to 'unknown' but callers should always pass one.
   */
  analyticsSource?: EventSource;
};

const BookAppointmentLink: React.FC<Props> = ({
  to = '/book',
  children,
  className,
  'aria-label': ariaLabel,
  analyticsSource = 'unknown',
  onClick,
  ...rest
}) => (
  <Link
    to={to}
    className={className}
    aria-label={ariaLabel ?? BOOK_APPOINTMENT_ARIA_LABEL}
    onClick={(e) => {
      trackBookingCtaClick(analyticsSource);
      onClick?.(e);
    }}
    {...rest}
  >
    {children}
  </Link>
);

export default BookAppointmentLink;
